import React from 'react';
import axios from 'axios';
import {useState,useEffect} from 'react';
import {useParams} from "react-router-dom";

const Policy=()=>{
    // const [mission, setMission] = useState(props.location.state.mission);
    
    // const [policy_code, setPolicyCode] = useState(props.match.params.code)
	let { code } = useParams();
	const [policy, setPolicy] = useState("")

	
	const fetchPolicy = async (id) =>{
		console.log("fetchPolicy")
		console.log(code)
		const url = '/policy/'+id;
		const option ={
		  url,
		  method:'GET',
		  headers:{
			'Accept':'application/json',
			'Content-Type':'application/json',
			// 'Authorization': token
		  }        
		};
		axios(option).then(
		  response => {
			console.log('policy info')
			console.log(response.data)
			setPolicy(response.data)
			
		});
	  }
	  useEffect(()=>{
		console.log("hele" +code)      
		fetchPolicy(code)

	  }, []);
	  return(
        <>
		<div
		dangerouslySetInnerHTML={{__html: policy.content}}
		/>
		</>

);
};

export default Policy